import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import keymaster from 'keymaster';
import { Modal } from 'react-bootstrap';

class ProjectNameModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        ReactDOM.findDOMNode(this.refs.confirmButton).focus();
        keymaster.unbind('left');
        keymaster.unbind('right');
    }

    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
    }

    handleConfirm = () => {
        this.props.handleConfirm(this.props.attributeValues, this.props.project);
        this.handleClose();
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Change Project Name</h4>
                        </div>
                        <div className="modal-body text-center">
                            <div className="row">
                                <i>{this.props.project.name.toUpperCase()}</i> has the same project name for CV and customer as the following projects:
                            </div>
                            <br/>
                            <div className="row">
                                {this.props.projects.map((project, i) => {
                                    return <div key={i}><b>{project.name.toUpperCase()}</b></div>
                                })}
                            </div>
                            <br/>
                            <div className="row">
                                Taggy is going to view the listed projects as a single project. Are you sure this is right?
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" ref="confirmButton"  onClick={this.handleConfirm} className="btn btn-default btn-large">Yes</button>
                            <button type="button" ref="closeButton" onClick={this.handleClose} className="btn btn-default btn-discrete">Close</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

ProjectNameModal.propTypes = {
    handleClose: PropTypes.func,
    handleConfirm: PropTypes.func,
    status: PropTypes.bool
};

export default connect()(ProjectNameModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/ProjectNameModal.js
 **/